import {Component, Input, OnInit} from '@angular/core';
import {NotificationState} from '../../../models/notification-state';

@Component({
  selector: 'app-simple-notification',
  templateUrl: './simple-notification.component.html',
  styleUrls: []
})
export class SimpleNotificationComponent implements OnInit {

  @Input() notificationState: NotificationState;
  @Input() loaderVisible: boolean;
  @Input() shouldTranslateMessage: boolean;

  get message(): string {
    return (this.notificationState && this.notificationState.message) ? this.notificationState.message : '';
  }

  constructor() { }

  ngOnInit() {
  }

}
